import React from 'react';

const Education = () => {
  return (
    <section id="education" className="wrap">
      <h2 className="section-title reveal">Education</h2>
      <div className="timeline reveal">
        <div className="t-item">
          <h3> BSc (Hons) in Computer Science and Technology (Reading)</h3>
          <div className="when">Uva Wellassa University of Sri Lanka, Badulla — 2022 – Present</div>
        </div>
        <div className="t-item">
          <h3> G.C.E Advanced Level (Physical Science stream)</h3>
          <div className="when">Rippon Girls' College, Galle — 2020</div>
        </div>
      </div>
    </section>
  );
};

export default Education;